import React from 'react';
import { CnLayoutHeader as UICnLayoutHeader } from "../../components/cn-layout";
var CnLayoutHeader = function CnLayoutHeader(props) {
  var _ref = props || {},
    children = _ref.children,
    title = _ref.title,
    desc = _ref.desc,
    label = _ref.label,
    avatar = _ref.avatar;
  var realLabel = label && label.map(function (item) {
    return item === null || item === void 0 ? void 0 : item.name;
  });
  return /*#__PURE__*/React.createElement(UICnLayoutHeader, {
    title: title,
    desc: desc,
    avatar: avatar,
    label: realLabel
  }, children);
};
CnLayoutHeader.displayName = 'CnLayoutHeader';
CnLayoutHeader.typeMark = 'Header';
export default CnLayoutHeader;
export { CnLayoutHeader };